import { render, staticRenderFns } from "./AdminListTop.vue?vue&type=template&id=1d782ef4&"
import script from "./AdminListTop.vue?vue&type=script&lang=ts&"
export * from "./AdminListTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports